<template lang="pug">
#laudo-empresa
    el-card.mb-4.box-card(
        shadow='never',
        :body-style='{ padding: "10px" }',
        style='margin: 20px'
    )
        h3.mb-3
            i.mdi.mdi-filter-variant.mr-2
            | Filtros

        .filtros__input.mb-3
            el-select(
                v-model='laudosSelecionados',
                style='width: 50%',
                placeholder='Selecione os laudos',
                multiple,
                filterable,
                value-key='idLaudo'
            )
                el-option(
                    v-for='laudo in laudos',
                    :key='laudo.codigo',
                    :label='laudo.nome',
                    :value='laudo.id'
                )

            el-select(
                v-model='empresasSelecionadas',
                style='width: 50%',
                placeholder='Selecione as empresas',
                multiple,
                filterable,
                value-key='idEmpresas'
            )
                el-option(
                    v-for='empresa in empresas',
                    :key='empresa.id',
                    :label='empresa.name',
                    :value='empresa.id'
                )

        .filtros__botao
            BaseButton(
                type='primary',
                size='mini',
                icon='el-icon-receiving',
                @click='buscarQtdLaudosPorEmpresa'
            ) Filtrar

    el-card.mb-4.box-card(
        shadow='never',
        :body-style='{ padding: "10px" }',
        style='margin: 20px'
    )
        .justify-content-end.d-flex
            el-button-group.mb-2
                BaseButton(
                    type='primary',
                    icon='el-icon-plus',
                    size='mini',
                    @click='mostrarModalVincular'
                ) Vincular laudo em lote
                BaseButton(
                    type='primary',
                    icon='el-icon-delete',
                    size='mini',
                    @click='mostrarModalRemover'
                ) Remover laudo em lote

        el-table.px-2(
            v-loading='carregandoTabela',
            :data='paginaQtdLaudosPorEmpresa.itens',
            size='mini'
        )
            el-table-column(
                label='Empresa (Grupo)',
                prop='nomeEmpresa',
                sortable,
                :min-width='25'
            )
            el-table-column(
                label='Número de laudos vinculados',
                prop='qtdLaudos',
                sortable,
                :min-width='25',
                align='center'
            )
            el-table-column(label='Ação', :min-width='15', align='center')
                .template(slot-scope='scope')
                    el-dropdown.action-button(trigger='click')
                        span.el-dropdown-link
                            i.el-icon-caret-bottom
                        el-dropdown-menu(slot='dropdown')
                            el-dropdown-item(
                                icon='el-icon-view',
                                @click.native='visualizarLaudosEmpresa(scope.row)'
                            ) Visualizar laudos vinculados

                            el-dropdown-item(
                                icon='el-icon-edit',
                                @click.native='editarLaudosEmpresa(scope.row)'
                            ) Editar laudos vinculados

        .mt-4.px-2.justify-content-between.d-flex.align-items-center
            .totalizadores
                label.mr-3 Empresas: {{ empresas.length }}
                label Laudos vinculados: {{ totalLaudosVinculados }}

            el-pagination(
                small,
                background,
                layout='prev, pager, next',
                :page-size='paginacao.tamanho',
                :current-page.sync='paginacao.pagina',
                :total='paginaQtdLaudosPorEmpresa.totalItens',
                @current-change='atualizarPagina'
            )

    ModalVincularLaudos(
        :mostrar='mostrarModalVincularLaudos',
        :empresas='empresas',
        :laudos='laudos',
        :acao='acaoModal',
        @atualizar-tabela='buscarQtdLaudosPorEmpresa',
        @fechar='mostrarModalVincularLaudos = false'
    )

    ModalVisualizarLaudosVinculados(
        :mostrar='mostrarModalVisualizarLaudos',
        :empresa='empresaModalVisualizarLaudos',
        @fechar='mostrarModalVisualizarLaudos = false'
    )

    ModalEditarLaudosVinculados(
        :mostrar='mostrarModalEditarLaudos',
        :empresa='empresaModalEditarLaudos',
        :laudos='laudos',
        @atualizar-tabela='buscarQtdLaudosPorEmpresa',
        @fechar='mostrarModalEditarLaudos = false'
    )
</template>

<script>
import LaudoEmpresaService from '@/services/LaudoEmpresaService';
import ModalVincularLaudos from '@/components/adminRelatorios/ModalVincularLaudosEmLote';
import ModalVisualizarLaudosVinculados from '@/components/adminRelatorios/ModalVisualizarLaudosVinculados';
import ModalEditarLaudosVinculados from '@/components/adminRelatorios/ModalEditarLaudosVinculados';
import BaseButton from '@/components/vegaComponents/BaseButton.vue';

export default {
    name: 'LaudoEmpresa',

    components: {
        ModalVincularLaudos,
        ModalVisualizarLaudosVinculados,
        ModalEditarLaudosVinculados,
        BaseButton
    },

    props: {
        empresas: {
            type: Array,
            required: true
        }
    },

    data() {
        return {
            laudos: [],
            laudosSelecionados: [],
            empresasSelecionadas: [],
            totalLaudosVinculados: 0,

            paginaQtdLaudosPorEmpresa: {},
            paginacao: {
                pagina: 0,
                tamanho: 50
            },

            mostrarModalVincularLaudos: false,
            acaoModal: '',

            mostrarModalVisualizarLaudos: false,
            empresaModalVisualizarLaudos: {},

            mostrarModalEditarLaudos: false,
            empresaModalEditarLaudos: {},

            carregandoTabela: false,
            carregandoTotalizadores: false
        };
    },

    mounted() {
        this.buscarLaudos();
        this.buscarEmpresas();
        this.buscarTotalLaudosVinculados();
        this.buscarQtdLaudosPorEmpresa();
    },

    methods: {
        buscarEmpresas() {
            this.$emit('buscarEmpresas');
        },

        async buscarLaudos() {
            const { data } = await LaudoEmpresaService.buscarTiposLaudo();
            this.laudos = data.itens;
        },

        async buscarQtdLaudosPorEmpresa() {
            this.carregandoTabela = true;

            const { data } = await LaudoEmpresaService.buscarQtdLaudosPorEmpresa(
                {
                    idsLaudos: this.laudosSelecionados,
                    idsEmpresas: this.empresasSelecionadas
                },
                this.paginacao
            );

            this.paginaQtdLaudosPorEmpresa = data;
            this.carregandoTabela = false;
        },

        async buscarTotalLaudosVinculados() {
            const { data } = await LaudoEmpresaService.buscarTotalLaudosVinculados();
            this.totalLaudosVinculados = data;
        },

        atualizarPagina(pagina) {
            this.paginacao.pagina = pagina;
            this.buscarQtdLaudosPorEmpresa();
        },

        mostrarModalVincular() {
            this.acaoModal = 'VINCULAR';
            this.mostrarModalVincularLaudos = true;
        },

        mostrarModalRemover() {
            this.acaoModal = 'REMOVER';
            this.mostrarModalVincularLaudos = true;
        },

        visualizarLaudosEmpresa(empresa) {
            this.empresaModalVisualizarLaudos = empresa;
            this.mostrarModalVisualizarLaudos = true;
        },

        editarLaudosEmpresa(empresa) {
            this.empresaModalEditarLaudos = empresa;
            this.mostrarModalEditarLaudos = true;
        }
    }
};
</script>

<style lang="scss" scoped>
.filtros__input {
    display: flex;
    align-items: flex-start;
    gap: 8px;
}

.filtros__botao {
    display: flex;
    justify-content: flex-end;
}

.el-table.px-2.el-table--fit.el-table--enable-row-hover.el-table--enable-row-transition {
    height: 350px;
    overflow: scroll;
}
</style>
